import { useCallback, useLoading } from 'hooks'

import { urlTo, goTo } from 'helpers/router.js'

import { showFailToast } from 'app/redux/actions/ui'
import { setup2fa } from 'app/redux/api/2fa'
import { ApiError } from 'app/redux/models/errors'

import { useReauth } from 'app/pages/Dashboard/UserProfile/hooks'

type UseDisableTwofactorAuthReturnProps = {
  isLoading: boolean
  handleContinue: () => Promise<void>
  handleBack: () => void
}

const useDisableTwofactorAuth = (): UseDisableTwofactorAuthReturnProps => {
  const { checkIsClientReauthorized } = useReauth()

  const { isLoading, wait } = useLoading(false)

  const goToPassword = useCallback(() => {
    goTo(urlTo('user-profile.two-factor-setup.disable-two-factor.password'))
  }, [])

  const handleContinue = useCallback(async () => {
    if (checkIsClientReauthorized()) {
      try {
        const data = await wait(setup2fa({ action: 'disable' }))

        if (data instanceof ApiError) {
          throw data
        }

        if (data.state === 'DISABLED') {
          const nextUrl = urlTo('dashboard.user-profile.login-settings', {}, { twoFactorAuthDisabled: true })

          goTo(nextUrl)
          return
        }

        showFailToast()
        return
      } catch (error) {
        goToPassword()
        return
      }
    }
    goToPassword()
  }, [checkIsClientReauthorized, goToPassword, wait])

  const handleBack = useCallback(() => {
    goTo(urlTo('user-profile.login-settings.two-factor-auth'))
  }, [])

  return {
    isLoading,
    handleContinue,
    handleBack,
  }
}

export { useDisableTwofactorAuth }
